import { RowItem } from "../Table"
import { LONG_TERM_RESERVATION_KINDS, longTermReservationKind } from "~/constants"
import { INVOICE_STATUSES } from "~/decorators/InvoiceDecorator"
import moment from "moment"
import { CampProps } from "~/interfaces"
import { IUseTableRowResult } from "./interfaces/UseTableRowResult"
import parseDateTime from "../../../../utils/parseDateTime"

export interface IFormData {
  electric_rate: number
  rowItems: RowItem[]
}

const electricKinds: longTermReservationKind[] = [
  LONG_TERM_RESERVATION_KINDS.RENT_AND_UTILITIES,
  LONG_TERM_RESERVATION_KINDS.UTILITIES_ONLY,
]

type Props = {
  rowItems: RowItem[]
  rowItem: RowItem
  isVisibleElectric: boolean
  camp: CampProps
}

export const useTableRowForPrint = ({ rowItems, rowItem, isVisibleElectric, camp }: Props): IUseTableRowResult => {
  const selectable = !!rowItem.invoice
  const refId = rowItem.invoiceId || rowItem.siteId
  const thisIndex = rowItems.findIndex((item) => item.invoiceId === refId || item.siteId === refId)
  const thisRowItem = rowItem.isSiteOnly
    ? rowItem
    : rowItems.find((item) => item.invoiceId === refId || item.siteId === refId) || rowItem

  const isMissingContactInfo = !thisRowItem.invoice?.recipient_email && !thisRowItem.invoice?.recipient_phone
  const isShowingElectricFields =
    isVisibleElectric &&
    (electricKinds.includes(thisRowItem.reservationRecurringKind as longTermReservationKind) || thisRowItem.isSiteOnly)

  const hasSendDate =
    !thisRowItem.isSiteOnly &&
    thisRowItem.invoice.status !== INVOICE_STATUSES.DRAFT &&
    thisRowItem.invoiceSendDate &&
    !(thisRowItem.invoice.status === INVOICE_STATUSES.PAID && moment(thisRowItem.invoiceSendDate).isAfter(moment()))

  const isDueDateRed =
    thisRowItem.invoice.status === INVOICE_STATUSES.DRAFT &&
    parseDateTime(thisRowItem.invoice?.due_date, camp.timezone, { asMoment: true })?.isBefore(moment())

  const formattedDate = (date: string) => {
    const momentDate = parseDateTime(date, camp.timezone, { asMoment: true })
    if (!momentDate?.isValid()) return ""

    const isIncludingYear = momentDate.year() !== moment().year()
    return momentDate.format(isIncludingYear ? "MMM D 'YY" : "MMM D")
  }

  const onChangeLastMeterReading = () => { }

  const onChangeMeterReading = () => { }

  const onChangeElectricUsed = () => { }

  const dropdownOptionsFor = () => []

  return {
    isMissingContactInfo,
    thisRowItem,
    thisIndex,
    camp,
    selectable,
    isShowingElectricFields,
    isChanged: () => false,
    hasSendDate,
    isDueDateRed,
    formattedDate,
    onChangeLastMeterReading,
    onChangeMeterReading,
    onChangeElectricUsed,
    dropdownOptionsFor,
    setValue: () => { },
  }
}
